// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RobotFilledSvg from "@ant-design/icons-svg/es/asn/RobotFilled";
import AntdIcon from '../components/AntdIcon';

var RobotFilled = function RobotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RobotFilledSvg
  }));
};

RobotFilled.displayName = 'RobotFilled';
export default /*#__PURE__*/React.forwardRef(RobotFilled);